import ajaxServices from "utils/ajaxServices";
import {
    GET_CATEGORY_CMS_CONTENT,
    GET_PRODUCTS_BY_SKUS,
    GET_DEALS_PRODUCTS_BY_SKUS,
    GET_CURRENCY_SYMBOL
} from "../actionTypes/index";
import {
    getCategoryCMS as _getCategoryCMS,
    getProductsBySkus as _getProductsBySkus,
    getDealsProductsBySkus as _getDealsProductsBySkus,
    getProductsByURLKeys as _getProductsByURLKeys,
    getDealsProductsByURLKeys as _getDealsProductsByURLKeys,
    getCurrencySymbol as _getCurrencySymbol
 } from "config/queries";

 const loadingState = {
    cms: {},
    products: {},
    currency: false
 };

export const getCategoryCMSContent = (categoryId) => async (dispatch, getState) => {
    const state = getState().pageBuilder.categoryCmsContent?.[categoryId];
    const dateCreated = state?.dateCreated && new Date(state?.dateCreated);
    if ((!dateCreated || new Date() - dateCreated > 1 * 60000) && !loadingState.cms[categoryId]) {
        loadingState.cms[categoryId] = true;
        const response = await ajaxServices.fetchGraphQLGetRequest(_getCategoryCMS, {
            id: categoryId,
        });
        const category = response?.categories?.items[0];
        const payload = {
            content: category?.cms_block?.content || null,
            displayMode: category?.display_mode || null,
            name: category?.name || null,
            categoryId,
            dateCreated: new Date()
        }

        dispatch({ type: GET_CATEGORY_CMS_CONTENT, payload });
        loadingState.cms[categoryId] = false;
    }
};

const sortProducts = (skus, products) => {
    const items = products?.items || [];

    items.sort((a, b) => {
        const aIndex = skus.indexOf(a?.sku);
        const bIndex = skus.indexOf(b?.sku);
        return aIndex - bIndex;
    })

    return { items }
}

export const getProductsBySkus = ({ skus, id }) => async (dispatch, getState) => {
    const state = getState().pageBuilder.products[id];
    const dateCreated = state?.dateCreated && new Date(state?.dateCreated);
    if ((!dateCreated || new Date() - dateCreated > 1 * 60000) && !loadingState.products[id]) {
        loadingState.products[id] = true;
        const { products } = await ajaxServices.fetchGraphQLGetRequest(_getProductsBySkus, {
            skus,
            pageSize: skus.length
        });

        const sortedProducts = sortProducts(skus, products);

        const payload = {
            products: sortedProducts,
            id,
            dateCreated: new Date()
        }

        dispatch({ type: GET_PRODUCTS_BY_SKUS, payload });
        loadingState.products[id] = false;
    }
};

export const getDealsProductsBySkus = ({ skus, id }) => async (dispatch, getState) => {
    const state = getState().pageBuilder.products[id];
    const dateCreated = state?.dateCreated && new Date(state?.dateCreated);
    if ((!dateCreated || new Date() - dateCreated > 1 * 60000) && !loadingState.products[id]) {
        loadingState.products[id] = true;
        const { products } = await ajaxServices.fetchGraphQLGetRequest(_getDealsProductsBySkus, {
            skus,
            pageSize: skus.length
        });

        const sortedProducts = sortProducts(skus, products);

        const payload = {
            products: sortedProducts,
            id,
            dateCreated: new Date()
        }

        dispatch({ type: GET_DEALS_PRODUCTS_BY_SKUS, payload });
        loadingState.products[id] = false;
    }

};

export const getCurrencySymbol = () => async (dispatch, getState) => {
    const currencySymbol = getState().pageBuilder.currencySymbol;
    if (!loadingState.currency && !currencySymbol) {
        loadingState.currency = true;
        const { currency } = await ajaxServices.fetchGraphQLGetRequest(_getCurrencySymbol);
        const currencySymbol = currency?.base_currency_symbol;
        const payload = {
            currencySymbol: currencySymbol
        }
        currencySymbol && dispatch({ type: GET_CURRENCY_SYMBOL, payload });
        loadingState.currency = false;
    }
};
